import { render } from "./SentimentPopup.vue?vue&type=template&id=5b6a0794&scoped=true"
import script from "./SentimentPopup.vue?vue&type=script&lang=js"
export * from "./SentimentPopup.vue?vue&type=script&lang=js"

import "./SentimentPopup.vue?vue&type=style&index=0&id=5b6a0794&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6a0794"]])

export default __exports__